import type { IndicatorName } from "../model";

export interface IndicatorsConfig {
  name: IndicatorName;
  label: string;
}

export const INDICATORS: IndicatorsConfig[] = [
  {
    name: "acceleratorOscillator",
    label: "Accelerator Oscillator",
  },
  {
    name: "aDX",
    label: "ADX",
  },
  {
    name: "alligator",
    label: "Alligator",
  },
  {
    name: "aroon",
    label: "Aroon",
  },
  {
    name: "bollingerBands",
    label: "Bollinger Bands",
  },
  {
    name: "donchianChannel",
    label: "Donchian Channel",
  },
  {
    name: "fractal",
    label: "Fractal",
  },
  {
    name: "fractalChaosBands",
    label: "Fractal Chaos Bands",
  },
  {
    name: "ichimokuKinkoHyo",
    label: "Ichimoku Kinko Hyo",
  },
  {
    name: "mACD",
    label: "MACD",
  },
  {
    name: "osMA",
    label: "OsMA",
  },
  {
    name: "parabolicSAR",
    label: "Parabolic SAR",
  },
  {
    name: "rSI",
    label: "RSI",
  },
  {
    name: "stochasticOscillator",
    label: "Stochastic Oscillator",
  },
  {
    name: "superTrend",
    label: "SuperTrend",
  },
  {
    name: "zigZag",
    label: "ZigZag",
  },
];
